module.exports = __webpack_public_path__ + "img/delete-icon.e046d4fe.svg";